module.exports = __webpack_public_path__ + "static/media/image.1af13465.svg";